"use client";
import type { RowData } from "@tanstack/react-table";

import { useCallback } from "react";
import type { RecordDataSource, RecordTableState } from "../types";
import { useCursorWindow } from "./use-cursor-window";

export function useRecordWindow<TData extends RowData>(
  data: RecordDataSource<TData>,
  state: RecordTableState,
  infiniteScroll: boolean,
) {
  const cursorWindow = useCursorWindow(data, state.page, state.pageSize, state.setPage);
  const rows = data.mode === "cursor" ? (infiniteScroll ? data.rows : cursorWindow.rows) : data.rows;
  const rawCanLoadMore =
    data.mode === "cursor" ? cursorWindow.hasNext : data.mode === "offset" ? data.canLoadMore : undefined;
  const canLoadMore =
    rawCanLoadMore === undefined ? undefined : infiniteScroll ? rawCanLoadMore && !data.isLoading : rawCanLoadMore;
  const { page, setPage } = state;
  const onLoadMore = useCallback(() => setPage(page + 1), [page, setPage]);
  return { rows, canLoadMore, onLoadMore, page: cursorWindow.page };
}
